import React from "react";
import { useTranslation } from "react-i18next";
import DangerInfoDetailSections from "./danger-info/DangerInfoDetailSections";
import DangerInfoReferenceBlocks from "./danger-info/DangerInfoReferenceBlocks";
import DangerInfoSummarySection from "./danger-info/DangerInfoSummarySection";
import useDangerInfoView from "./danger-info/useDangerInfoView";

export default function DangerInfo({
  lat,
  lon,
  onClose,
  showEmptyState = false,
}) {
  const { t } = useTranslation();
  const dangerInfo = useDangerInfoView({ lat, lon });

  if (dangerInfo.error) {
    return <div className="danger-info-error">{t("danger_error")}</div>;
  }

  if (!dangerInfo.data) {
    return <div className="danger-info-loading">{t("danger_loading")}</div>;
  }

  return (
    <div className="danger-info-content">
      <DangerInfoSummarySection
        data={dangerInfo.data}
        showEmptyState={showEmptyState}
        t={t}
      />
      <DangerInfoDetailSections data={dangerInfo.data} t={t} />
      <DangerInfoReferenceBlocks
        data={dangerInfo.data}
        onClose={onClose}
        t={t}
      />
    </div>
  );
}
